// JsFromRoutes CacheKey 14e85c937aa01538add7371100431460
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  archive: /* #__PURE__ */ definePathHelper('post', '/admin/partners/:id/archive'),
  unarchive: /* #__PURE__ */ definePathHelper('post', '/admin/partners/:id/unarchive'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/partners'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/partners/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/partners/:id'),
}
